__turbopack_export_value__({
  "body-logo-18": "ReviewsMain-module-scss-module__CrxXTq__body-logo-18",
  "body-text-12": "ReviewsMain-module-scss-module__CrxXTq__body-text-12",
  "body-text-14": "ReviewsMain-module-scss-module__CrxXTq__body-text-14",
  "body-text-16": "ReviewsMain-module-scss-module__CrxXTq__body-text-16",
  "body-text-18": "ReviewsMain-module-scss-module__CrxXTq__body-text-18",
  "body-text-20": "ReviewsMain-module-scss-module__CrxXTq__body-text-20",
  "body-text-24": "ReviewsMain-module-scss-module__CrxXTq__body-text-24",
  "body-text-24-2": "ReviewsMain-module-scss-module__CrxXTq__body-text-24-2",
  "body-text-heading-2": "ReviewsMain-module-scss-module__CrxXTq__body-text-heading-2",
  "body-text-heading-3": "ReviewsMain-module-scss-module__CrxXTq__body-text-heading-3",
  "body-text-medium-14": "ReviewsMain-module-scss-module__CrxXTq__body-text-medium-14",
  "body-text-medium-16": "ReviewsMain-module-scss-module__CrxXTq__body-text-medium-16",
  "body-text-medium-18": "ReviewsMain-module-scss-module__CrxXTq__body-text-medium-18",
  "body-text-medium2-18": "ReviewsMain-module-scss-module__CrxXTq__body-text-medium2-18",
  "body-text2-14": "ReviewsMain-module-scss-module__CrxXTq__body-text2-14",
  "body-text2-16": "ReviewsMain-module-scss-module__CrxXTq__body-text2-16",
  "button-primary-text": "ReviewsMain-module-scss-module__CrxXTq__button-primary-text",
  "button-text": "ReviewsMain-module-scss-module__CrxXTq__button-text",
  "button2-text": "ReviewsMain-module-scss-module__CrxXTq__button2-text",
  "card-shadow": "ReviewsMain-module-scss-module__CrxXTq__card-shadow",
  "effect-menu": "ReviewsMain-module-scss-module__CrxXTq__effect-menu",
  "header-1": "ReviewsMain-module-scss-module__CrxXTq__header-1",
  "main-container": "ReviewsMain-module-scss-module__CrxXTq__main-container",
  "main-footer-container": "ReviewsMain-module-scss-module__CrxXTq__main-footer-container",
  "main-header-container": "ReviewsMain-module-scss-module__CrxXTq__main-header-container",
  "reviews": "ReviewsMain-module-scss-module__CrxXTq__reviews",
  "reviews__head": "ReviewsMain-module-scss-module__CrxXTq__reviews__head",
  "reviews__link": "ReviewsMain-module-scss-module__CrxXTq__reviews__link",
  "reviews__link_mobile": "ReviewsMain-module-scss-module__CrxXTq__reviews__link_mobile",
  "reviews__list": "ReviewsMain-module-scss-module__CrxXTq__reviews__list",
  "reviews__modal": "ReviewsMain-module-scss-module__CrxXTq__reviews__modal",
  "txt-12-bold": "ReviewsMain-module-scss-module__CrxXTq__txt-12-bold",
  "txt-14-bold": "ReviewsMain-module-scss-module__CrxXTq__txt-14-bold",
  "txt-14-bold-caps": "ReviewsMain-module-scss-module__CrxXTq__txt-14-bold-caps",
  "txt-14-med": "ReviewsMain-module-scss-module__CrxXTq__txt-14-med",
  "txt-16-bold": "ReviewsMain-module-scss-module__CrxXTq__txt-16-bold",
  "txt-16-med": "ReviewsMain-module-scss-module__CrxXTq__txt-16-med",
  "txt-18-bold": "ReviewsMain-module-scss-module__CrxXTq__txt-18-bold",
  "txt-18-medium": "ReviewsMain-module-scss-module__CrxXTq__txt-18-medium",
  "txt-18-medium-24": "ReviewsMain-module-scss-module__CrxXTq__txt-18-medium-24",
  "txt-24-semi": "ReviewsMain-module-scss-module__CrxXTq__txt-24-semi",
});
